import {Action} from '@ngrx/store';
import { AdminSession, CustomerSession } from 'libs/tm-common/src/lib/models/user.model';

export enum AuthActionTypes {
	EnrichAuthStateAction = '[Auth] Enrich Auth State',
	EnrichAuthStateAdminAction = '[Auth] Enrich Auth State Admin',
	LogoutAction = '[Auth] Logout',
	NoHttpAuthAction = '[AuthHttpInterceptor] No HTTP Auth',
	ClearAuthStateAction = '[Auth] Clear Auth State'
}
export class EnrichAuthStateAction implements Action {
	readonly type = AuthActionTypes.EnrichAuthStateAction;
	constructor(public payload: CustomerSession) { }
}
export class EnrichAuthStateAdminAction implements Action {
	readonly type = AuthActionTypes.EnrichAuthStateAdminAction;
	constructor(public payload: AdminSession) { }
}
export class LogoutAction implements Action {
	readonly type = AuthActionTypes.LogoutAction;
}
export class NoHttpAuthAction implements Action {
	readonly type = AuthActionTypes.NoHttpAuthAction;
}
export class ClearAuthStateAction implements Action {
	readonly type = AuthActionTypes.ClearAuthStateAction;
}

export type AuthActions =
	| ClearAuthStateAction
    | EnrichAuthStateAction
	| EnrichAuthStateAdminAction
	| LogoutAction
	| NoHttpAuthAction;
